<h5 *ngIf="listHeading">{{listHeading}}</h5>
<ul *ngIf="listType === 'ul'" [style.list-style-type]="'disc'">
    <li *ngFor="let listitem of (listItems || [])" [innerHTML]="processText(listitem)"></li>
</ul>
<ol *ngIf="listType === 'ol'" [style.list-style-type]="'decimal'">
    <li *ngFor="let listitem of (listItems || [])" [innerHTML]="processText(listitem)"></li>
</ol>
<ol *ngIf="listType === 'lower-alpha'" [style.list-style-type]="'lower-alpha'">
    <li *ngFor="let listitem of (listItems || [])" [innerHTML]="processText(listitem)"></li>
</ol>
<ol *ngIf="listType === 'lower-roman'" [style.list-style-type]="'lower-roman'">
    <li *ngFor="let listitem of (listItems || [])" [innerHTML]="processText(listitem)"></li>
</ol>